var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 27,
    viewBox: "0 0 22 27",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.1664V22.9815C17.5 24.1916 16.5 25.2 15.3 25.2H3.9C2.7 25.2 1.7 24.1916 1.7 22.9815V7.14959C1.7 5.93951 2.7 4.93109 3.9 4.93109",
    stroke: "#4F4F4F",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 21.4689H6.8C5.6 21.4689 4.6 20.4605 4.6 19.2504V3.41848C4.6 2.2084 5.6 1.20001 6.8 1.20001H18.2C19.4 1.20001 20.4 2.2084 20.4 3.41848V19.1496C20.4 20.4605 19.4 21.4689 18.2 21.4689Z",
    stroke: "#4F4F4F",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.1c411362b3e0932444a7001e0fe95ad3.svg";
export { ForwardRef as ReactComponent };